export const mapMarkerIcons = {
    defaultIcon: {
        iconUrl: 'content/images/map/markers/marker-icon.png',
        shadowUrl: 'content/images/map/markers/marker-shadow.png',
        iconSize: [25, 41],
        shadowAnchor: [2, 21]
    },
    informationIcon: {
        iconUrl: 'content/images/map/markers/marker-icon-0.png',
        shadowUrl: 'content/images/map/markers/marker-shadow.png',
        iconSize: [25, 41],
        shadowAnchor: [2, 21]
    },
    warningIcon: {
        iconUrl: 'content/images/map/markers/marker-icon-1.png',
        shadowUrl: 'content/images/map/markers/marker-shadow.png',
        iconSize: [25, 41],
        shadowAnchor: [2, 21]
    },
    criticalIcon: {
        iconUrl: 'content/images/map/markers/marker-icon-2.png',
        shadowUrl: 'content/images/map/markers/marker-shadow.png',
        iconSize: [25, 41],
        shadowAnchor: [2, 21]
    }
};
